export default "__VITE_ASSET__f5e56982__"